import { Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { MainLayout } from '@/components/Layout';
import { ParentProfilePage } from '@/features/availability';
import { CancelAppointment } from '@/features/cancelAppointment';
import { UpdatePassword } from '@/features/updatePassword';
import Lottie from 'lottie-react';
import appCompoLoading from '@/assets/animation/loading.json';
import { PetDetailPage } from '@/features/availability/routes/PetDetailPage';
import { ReviewComponent } from '@/features/availability/components/Review';
import { PetsListPage } from '@/features/availability/routes/PetListPage';
import { LoginPage } from '@/features/availability/routes/LoginPage';
import { OpenReviewComponent } from '@/features/availability/components/OpenReviews';
import { PayInvoice } from '@/features/pay-invoice';
import ScheduleDemo from '@/features/availability/routes/ScheduleDemo';
import { PetStores } from '@/features/petStores/routes/PetStores';
import MyAppointments from '@/features/availability/routes/MyAppointments';
import MyPaymentMethods from '@/features/availability/routes/MyPaymentMethods';
import MyProfile from '@/features/availability/routes/MyProfile';
import MyPetProfiles from '@/features/availability/routes/MyPetProfiles';
import MyPetProfile from '@/features/availability/routes/MyPetProfile';
import PaymentRequestStripe from '@/features/payment-request/routes/RequestPayment';
import ScheduleAppointmentStripe from '@/features/availability/routes/ScheduleAppoinmtent';

import LandingPage from '@/features/availability/routes/LandingPage';
import DemoVideo from '@/features/availability/routes/DemoVideo';
import { useAuth } from '@/lib/auth';
import { MessagesDemo } from '@/features/petStores/routes/MessagesDemo';
import TermsOfService from '@/features/availability/routes/termsOfService';
import DemoThankYouPage from '@/features/availability/routes/DemoThankYouPage';

const App = () => {
  const { user } = useAuth();
  const location = useLocation();
  useEffect(() => {
    //ReactGA.send({ hitType: "pageview", page: location.pathname, title: "Petsked-Customer-Application" });
  }, [location])
  
  return (
    <MainLayout>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Lottie className="h-60 w-60" animationData={appCompoLoading} />
          </div>
        }
      >
        <Routes>
          <Route path="/:slug" element={<ScheduleAppointmentStripe />} />
          <Route path="/pay" element={<PaymentRequestStripe />} />
          <Route path="/:slug/schedule-demo" element={<ScheduleDemo />} />
          <Route path="/:slug/demo-thankyou" element={<DemoThankYouPage />} />
          <Route path="/parent-profile" element={<ParentProfilePage />} />
          <Route path="/pet-profile" element={<PetDetailPage />} />
          <Route path="/pets-list" element={<PetsListPage />} />
          <Route path="/:slug/appointment/cancel" element={<CancelAppointment key={'appointment'} />} />
          <Route path="/:slug/booking/cancel" element={<CancelAppointment  key={'booking'} />} />

          <Route path="/:slag/reviews" element={<OpenReviewComponent />} />
          <Route path="/reviews" element={<ReviewComponent />} />
          <Route path="/reset-password" element={<UpdatePassword />} />
          <Route path="/login" element={<LoginPage />} />
          {/* <Route path="/pay" element={<PayInvoice />} /> */}
          <Route path="/shops" element={<PetStores />} />
          <Route path="/messages-demo" element={<MessagesDemo />} />
          <Route path="/my-appointments" element={<MyAppointments key={'my-appointments'} />} />
          <Route path="/my-bookings" element={<MyAppointments key={'my-bookings'} />} />

          <Route path="/my-profile" element={<MyProfile />} />
          <Route path="/my-payment-methods" element={<MyPaymentMethods />} />
          <Route path="/my-pet-profiles" element={<MyPetProfiles />} />
          <Route path="/pet-profile/:id" element={<MyPetProfile />} />

          <Route path="/groomwest" element={<LandingPage />} />

          <Route path="/" element={<PetStores />} />
          <Route path="/groomwest" element={<LandingPage />} />
          <Route path="/demo" element={<DemoVideo />} />
          <Route path="/:slug/terms" element={<TermsOfService />} />
        </Routes>
      </Suspense>
    </MainLayout>
  );
};

export const publicRoutes = [
  {
    path: '/*',    element: <App />,
  },
];
